import { katTranslator } from '../../shared/i18n';

export const strings = {
  'comment-prompt': {
    'en-US': 'What is your feedback?',
    'it-IT': "Che cos'è il feedback?",
    'fr-FR': 'Quelle est votre évaluation ?Q',
    'fr-BE': 'Quelle est votre évaluation ?Q',
    'ja-JP': 'ご意見を入力してください。',
    'es-ES': '¿Cuál es tu valoración?',
    'es-MX': '¿Cuál es tu valoración?',
    'pt-BR': 'Qual é a sua avaliação?',
    'zh-CN': '您的反馈是什么？',
    'tr-TR': 'Geri bildiriminiz nedir?',
    'ko-KR': '귀하의 피드백은 무엇입니까?',
    'de-DE': 'Wie lautet Ihre Bewertung?',
    'ar-AE': 'ما هي ملاحظاتك؟',
    'nl-NL': 'Wat is je feedback?',
    'nl-BE': 'Wat is je feedback?',
    'pl-PL': 'Jakie jest Twoje zdanie?',
    'hi-IN': 'आपका फ़ीडबैक क्या है?',
    'ta-IN': 'உங்கள் ஃபீட்பேக் என்ன?',
    'bn-IN': 'আপনার প্রতিক্রিয়া কী?',
    'gu-IN': 'તમારો ફીડબેક શું છે?',
    'ml-IN': 'നിങ്ങളുടെ ഫീഡ്ബാക്ക് എന്താണ്?',
    'te-IN': 'మీ ఫీడ్‌బ్యాక్ ఏమిటి?',
    'vi-VN': 'Hãy cho biết phản hồi của bạn?',
    'zh-TW': '您有哪些意見回饋？',
    'pt-PT': 'Qual é o seu feedback?',
  },
  'rating-prompt': {
    'en-US': 'How satisfied are you with the features on this page?',
    'it-IT':
      'Quanto ti soddisfano le funzionalità disponibili in questa pagina?',
    'fr-FR':
      'Quel est votre degré de satisfaction concernant les fonctionnalités de cette page ?',
    'fr-BE':
      'Quel est votre degré de satisfaction concernant les fonctionnalités de cette page ?',
    'ja-JP': 'このページの機能にどのくらい満足していただけましたか？',
    'es-ES':
      '¿Cuál es tu nivel de satisfacción con las funcionalidades de esta página?',
    'es-MX':
      '¿Cuál es tu nivel de satisfacción con las funcionalidades de esta página?',
    'pt-BR': 'Qual é o seu nível de satisfação com os recursos nesta página?',
    'zh-CN': '您对此页面上的几种功能的满意度如何？您',
    'tr-TR': 'Bu sayfadaki özelliklerden ne kadar memnunsunuz?',
    'ko-KR': '이 페이지의 기능에 대해 어느 정도 만족하십니까?이',
    'de-DE': 'Wie zufrieden sind Sie mit den Funktionen auf dieser Seite?',
    'ar-AE': 'ما مدى رضاك ​​عن الميزات الموجودة في هذه الصفحة؟',
    'nl-NL': 'Hoe tevreden ben je over de functies op deze pagina?',
    'nl-BE': 'Hoe tevreden ben je over de functies op deze pagina?',
    'pl-PL': 'Jak oceniasz swój stopień zadowolenia z funkcji na tej stronie?',
    'hi-IN': 'आप इस पेज पर दिए गए फ़ीचर से कितना संतुष्ट हैं?',
    'ta-IN':
      'இந்தப் பக்கத்தில் உள்ள அம்சங்களில் நீங்கள் எவ்வளவு திருப்தி அடைகிறீர்கள்?',
    'bn-IN': 'এই পৃষ্ঠার ফিচারগুলিতে আপনি কতটা সন্তুষ্ট?',
    'gu-IN': 'આ પેજ પરની સુવિધાઓથી તમે કેટલા સંતુષ્ટ છો?',
    'ml-IN': 'ഈ പേജിലെ ഫീച്ചറുകളിൽ നിങ്ങൾ എത്രത്തോളം സംതൃപ്തരാണ്?',
    'te-IN': 'ఈ పేజీలోని ఫీచర్‌లతో మీరు ఎంత మేరకు సంతృప్తి చెందారు?',
    'vi-VN': 'Bạn hài lòng như thế nào với các tính năng trên trang này?',
    'zh-TW': '您對本頁功能的滿意度如何？',
    'pt-PT': 'Quão satisfeito está com os recursos desta página?',
  },
  'submit-label': {
    'en-US': 'Submit',
    'it-IT': 'Invia',
    'fr-FR': 'Envoyer',
    'fr-BE': 'Envoyer',
    'ja-JP': '送信',
    'es-ES': 'Enviar',
    'pt-BR': 'Enviar',
    'zh-CN': '提交',
    'tr-TR': 'Gönder',
    'ko-KR': '제출제',
    'de-DE': 'Absenden',
    'ar-AE': 'إرسال',
    'nl-NL': 'Indienen',
    'nl-BE': 'Indienen',
    'pl-PL': 'Prześlij',
    'hi-IN': 'सबमिट करें',
    'ta-IN': 'சமர்ப்பி',
    'bn-IN': 'জমা দিন',
    'gu-IN': 'સબમિટ કરો',
    'ml-IN': 'സമർപ്പിക്കുക',
    'te-IN': 'సమర్పించండి',
    'vi-VN': 'Gửi',
    'zh-TW': '提交',
    'pt-PT': 'Enviar',
  },
  'cancel-label': {
    'en-US': 'Cancel',
    'it-IT': 'Annulla',
    'fr-FR': 'Annuler',
    'fr-BE': 'Annuler',
    'ja-JP': 'キャンセル',
    'es-ES': 'Cancelar',
    'es-MX': 'Cancelar',
    'pt-BR': 'Cancelar',
    'zh-CN': '取消',
    'tr-TR': 'İptal',
    'ko-KR': '취소',
    'de-DE': 'Abbrechen',
    'ar-AE': 'إلغاء',
    'nl-NL': 'Annuleren',
    'nl-BE': 'Annuleren',
    'pl-PL': 'Anuluj',
    'hi-IN': 'कैंसल करें',
    'ta-IN': 'ரத்துசெய்',
    'bn-IN': 'ক্যান্সেল করুন',
    'gu-IN': 'કેન્સલ કરો',
    'ml-IN': 'റദ്ദാക്കുക',
    'te-IN': 'రద్దు చేయండి',
    'vi-VN': 'Hủy',
    'zh-TW': '取消',
    'pt-PT': 'Cancelar',
  },
  charlimit: {
    'en-US': '500 character limit',
    'it-IT': 'Limite di 500 caratteri',
    'fr-FR': 'Limite de 500 caractères',
    'fr-BE': 'Limite de 500 caractères',
    'ja-JP': '500 文字の制限',
    'es-ES': 'Límite de 500 caracteres',
    'es-MX': 'Cancelar',
    'pt-BR': 'Limite de 500 caracteres',
    'zh-CN': '500字符极限',
    'tr-TR': '500 karakter sınırı',
    'ko-KR': '500 자 제한',
    'de-DE': 'Maximal 500 Zeichen',
    'ar-AE': 'لحد 500 حرف',
    'nl-NL': 'Limiet van 500 tekens',
    'nl-BE': 'Limiet van 500 tekens',
    'pl-PL': 'Limit znaków 500',
    'hi-IN': '500 कैरेक्टर लिमिट',
    'ta-IN': '500 எழுத்து வரம்பு',
  },
  disclaimer: {
    'en-US':
      'Examples of personal or sensitive data include names, addresses, telephone numbers, or email addresses. Personal or sensitive data is not necessary to complete this survey. By submitting your response, you agree you have not included this data.',
    'zh-CN':
      '个人或敏感数据的示例包括姓名、地址、电话号码或电子邮件地址。 完成此调查不需要个人或敏感数据。 提交您的回复，即表示您同意您未包含此数据。',
    'fr-FR':
      'Les exemples de données personnelles ou sensibles incluent les noms, les adresses, les numéros de téléphone, ou les adresses e-mail. Les données personnelles ou sensibles ne sont pas nécessaires pour répondre à ce questionnaire. En soumettant votre réponse, vous acceptez que vous n’avez pas inclus ces données.',
    'fr-BE':
      'Les exemples de données personnelles ou sensibles incluent les noms, les adresses, les numéros de téléphone, ou les adresses e-mail. Les données personnelles ou sensibles ne sont pas nécessaires pour répondre à ce questionnaire. En soumettant votre réponse, vous acceptez que vous n’avez pas inclus ces données.',
    'it-IT':
      'Esempi di dati personali o sensibili sono nome, indirizzo, telefono, indirizzo e-mail. Non è necessario inserire dati personali o sensibili per completare questo sondaggio. Inviando la tua risposta, accetti e confermi di non aver inserito tali dati.',
    'es-ES':
      'Ejemplos de datos personales o confidenciales: nombres o números de teléfono, direcciones de correo electrónico, etc. Los daros personales o confidenciales no son necesarios para completar esta encuesta. Al enviar esta respuesta de encuesta, garantizas que no has incluido ningún dato de este tipo.',
    'de-DE':
      'Beispiele für persönliche oder vertrauliche Daten sind Namen, Adressen, Telefonnummern und E-Mail-Adressen.  Persönliche oder vertrauliche Daten sind nicht erforderlich, um an dieser Umfrage teilzunehmen.  Mit der Übermittlung Ihrer Antwort bestätigen Sie, dass Sie keine dieser Daten hinzugefügt haben. ',
    'es-MX':
      'Ejemplos de información personal o confidencial incluyen nombres, direcciones, números telefónicos o direcciones de correo electrónico. No es necesario proporcionar información personal o confidencial para completar esta encuesta. Al enviar tu respuesta, aceptas que no se incluyen estos datos.',
    'en-IN':
      'Examples of personal or sensitive data include names, addresses, telephone numbers or email addresses. Personal or sensitive data is not necessary to complete this survey. By submitting your response, you agree you have not included this data.',
    'pt-BR':
      'Exemplos de dados pessoais ou confidenciais incluem nomes, endereços, números de telefone e endereços de e-mail. Dados pessoais ou confidenciais não são necessários para concluir esta pesquisa. Ao enviar sua resposta, você concorda que você não incluiu esses dados.',
    'ko-KR':
      '이름, 주소, 전화번호 또는 이메일 주소 등이 개인 또는 민감한 데이터에 포함됩니다. 이 설문 조사를 완료하기 위해 개인 또는 민감한 데이터를 제공할 필요가 없습니다. 귀하의 응답을 제출함으로써 이 데이터를 포함하지 않았다는 것에 동의하게 됩니다.',
    'ja-JP':
      '個人データまたは機密データの例には、名前、住所、電話番号、またはEメールアドレスなどがあります。 この調査を完了するには、個人データまたは機密データは必要ありません。 レスポンスを送信すると、このデータを含めなかったことに同意したとみなされます。',
    'tr-TR':
      'Kişisel veya hassas verilere örnek olarak; ad, adres, telefon numaraları veya e-posta adresleri gösterilebilir. Bu anketi tamamlamanız için kişisel veya hassas veriler gerekmemektedir. Bu anket yanıtlarınızı göndererek, anket yanıtlarınızda bu tür verilerin olmadığını beyan etmiş olursunuz.',
    'ar-AE':
      '. أمثلة على البيانات الشخصية أو الحساسة مثل الأسماء أو العناوين أو أرقام الهاتف أو عناوين البريد الإلكتروني. البيانات الشخصية أو الحساسة ليست ضرورية لاستكمال هذا الاستطلاع. بإرسال ردك ، أنت توافق على أنك لم تقم بإرسال هذه البيانات',
    'nl-NL':
      'Voorbeelden van persoonlijke of gevoelige gegevens zijn namen, adressen, telefoonnummers en e-mailadressen. Persoonlijke of gevoelige gegevens zijn niet nodig om deze enquête in te vullen. Door je reactie in te dienen, verklaar je dat je geen persoonlijke of gevoelige gegevens hebt opgenomen.',
    'nl-BE':
      'Voorbeelden van persoonlijke of gevoelige gegevens zijn namen, adressen, telefoonnummers en e-mailadressen. Persoonlijke of gevoelige gegevens zijn niet nodig om deze enquête in te vullen. Door je reactie in te dienen, verklaar je dat je geen persoonlijke of gevoelige gegevens hebt opgenomen.',
    'pl-PL':
      'Przykłady danych osobowych lub poufnych to imiona i nazwiska, adresy, numery telefonów lub adresy e-mail. Dane osobowe lub poufne nie są wymagane do wypełnienia tej ankiety. Wysyłając odpowiedź, zgadzasz się na to, że te dane nie zostały wysłane.',
    'hi-IN':
      'निजी या संवेदनशील डेटा के उदाहरणों में नाम, पता, टेलीफ़ोन नंबर या ईमेल पते शामिल हैं. इस सर्वे को पूरा करने के लिए व्यक्तिगत या संवेदनशील डेटा ज़रूरी नहीं है. अपना फ़ीडबैक देकर, आप सहमत हैं कि आपने यह डेटा शामिल नहीं किया है.',
    'ta-IN':
      'தனிப்பட்ட அல்லது முக்கியத் தரவுகளின் எடுத்துக்காட்டுகளில் பெயர்கள், முகவரிகள், ஃபோன் நம்பர்கள் அல்லது இமெயில் முகவரிகள் போன்றவை அடங்கும். இந்தப் புலத்தைப் பூர்த்தி செய்வதற்கு தனிப்பட்ட அல்லது முக்கியத் தரவுகள் தேவையில்லை. உங்கள் பதிலைச் சமர்ப்பிப்பதன் மூலம், நீங்கள் இந்தத் தரவுகளைச் சேர்க்கவில்லை என ஒப்புக்கொள்கிறீர்கள்.',
    'bn-IN':
      'ব্যক্তিগত বা সংবেদনশীল তথ্যের উদাহরণের মধ্যে রয়েছে নাম, ঠিকানা, টেলিফোন নম্বর, বা ইমেল ঠিকানা। এই সমীক্ষা সম্পূর্ণ করার জন্য ব্যক্তিগত বা সংবেদনশীল তথ্য প্রয়োজনীয় নয়। আপনার প্রতিক্রিয়া জমা দিয়ে, আপনি সম্মত হন যে আপনি এই তথ্য অন্তর্ভুক্ত করেননি।',
    'gu-IN':
      'વ્યક્તિગત અથવા સંવેદનશીલ ડેટાના ઉદાહરણોમાં નામો, સરનામાં, ટેલિફોન નંબરો અથવા ઈમેલ સરનામાંનો સમાવેશ થાય છે. આ સર્વેને પૂર્ણ કરવા માટે વ્યક્તિગત અથવા સંવેદનશીલ ડેટા જરૂરી નથી. તમારો પ્રતિસાદ સબમિટ કરીને, તમે સંમત થાઓ છો કે તમે આ ડેટા શામેલ કર્યો નથી.',
    'ml-IN':
      'പേഴ്സണൽ അല്ലെങ്കിൽ സെൻസിറ്റീവ് ഡാറ്റയുടെ ഉദാഹരണങ്ങളിൽ പേരുകൾ, വിലാസങ്ങൾ, ടെലിഫോൺ നമ്പറുകൾ അല്ലെങ്കിൽ ഇമെയിൽ വിലാസങ്ങൾ എന്നിവ ഉൾപ്പെടുന്നു. ഈ സർവേ പൂർത്തിയാക്കാൻ വ്യക്തിപരമോ സെൻസിറ്റീവ് ആയതോ ആയ ഡാറ്റ ആവശ്യമില്ല. നിങ്ങളുടെ പ്രതികരണം സമർപ്പിക്കുന്നതിലൂടെ, ഈ ഡാറ്റ ഉൾപ്പെടുത്തിയിട്ടില്ലെന്ന് നിങ്ങൾ സമ്മതിക്കുന്നു.',
    'te-IN':
      'వ్యక్తిగత లేదా సున్నితమైన డేటాకు ఉదాహరణలలో పేర్లు, చిరునామాలు, టెలిఫోన్ నంబర్లు లేదా ఇమెయిల్ చిరునామాలు ఉంటాయి. ఈ సర్వేను పూర్తి చేయడానికి వ్యక్తిగత లేదా సున్నితమైన డేటా అవసరం లేదు. మీ ప్రతిస్పందనను సమర్పించడం ద్వారా, మీరు ఈ డేటాను చేర్చలేదని మీరు అంగీకరిస్తున్నారు.',
    'vi-VN':
      'Ví dụ về dữ liệu cá nhân hoặc dữ liệu nhạy cảm bao gồm tên, địa chỉ, số điện thoại hoặc địa chỉ email. Không cần dữ liệu cá nhân hoặc dữ liệu nhạy cảm để hoàn thành bản khảo sát này. Bằng cách gửi phản hồi, bạn đồng ý rằng bạn sẽ không đưa dữ liệu này vào.',
    'zh-TW':
      '個人或敏感資料的範例包括姓名、地址、電話號碼或電子郵件地址。填寫這份問卷並不需要提供任何個人或敏感資料。提交回覆即表示您同意您未提供這類資料。',
    'pt-PT':
      'Exemplos de dados pessoais ou confidenciais incluem nomes, moradas, números de telefone ou endereços de e-mail. Não são necessários dados pessoais ou confidenciais para concluir este questionário. Ao enviar a sua resposta, concorda que não incluiu dados deste tipo.',
  },
  'subject-prompt': {
    'en-US': 'Feedback subject',
    'zh-CN': '反馈主题',
    'fr-FR': "Sujet de l'évaluation",
    'fr-BE': "Sujet de l'évaluation",
    'it-IT': 'Argomento del feedback',
    'es-ES': 'Asunto de la valoración',
    'de-DE': 'Thema der Bewertung',
    'es-MX': 'Asunto de la valoración',
    'pt-BR': 'Assunto da avaliação',
    'ko-KR': '피드백 제목',
    'ja-JP': '件名',
    'tr-TR': 'Geri bildirim konusu',
    'ar-AE': 'عنوان ملاحظاتك',
    'nl-NL': 'Feedbackonderwerp',
    'nl-BE': 'Feedbackonderwerp',
    'pl-PL': 'Temat opinii',
    'hi-IN': 'फ़ीडबैक का विषय',
    'ta-IN': 'ஃபீட்பேக் தலைப்பு',
    'bn-IN': 'প্রতিক্রিয়ার বিষয়',
    'gu-IN': 'ફીડબેક વિષય',
    'ml-IN': 'ഫീഡ്ബാക്ക് വിഷയം',
    'te-IN': 'ఫీడ్‌బ్యాక్ సబ్జెక్ట్',
    'vi-VN': 'Chủ đề phản hồi',
    'zh-TW': '意見反饋主題',
    'pt-PT': 'Assunto de feedback',
  },
  'subject-select': {
    'en-US': 'Select a subject',
    'zh-CN': '请选择一个主题',
    'fr-FR': 'Sélectionner un sujet',
    'fr-BE': 'Sélectionner un sujet',
    'it-IT': 'Seleziona un argomento',
    'es-ES': 'Selecciona un asunto',
    'de-DE': 'Wählen Sie ein Thema aus',
    'es-MX': 'Selecciona un asunto',
    'pt-BR': 'Selecionar um assunto',
    'ko-KR': '제목 선택',
    'ja-JP': '件名を選択',
    'tr-TR': 'Bir konu seçin',
    'ar-AE': 'إختر العنوان',
    'nl-NL': 'Selecteer een onderwerp',
    'nl-BE': 'Selecteer een onderwerp',
    'pl-PL': 'Wybierz temat',
    'hi-IN': 'कोई विषय चुनें',
    'ta-IN': 'ஒரு தலைப்பைத் தேர்ந்தெடுக்கவும்',
    'bn-IN': 'একটি বিষয় নির্বাচন করুন',
    'gu-IN': 'કોઈ વિષય પસંદ કરો',
    'ml-IN': 'ഒരു വിഷയം തിരഞ്ഞെടുക്കുക',
    'te-IN': 'ఒక విషయం ఎంచుకోండి',
    'vi-VN': 'Chọn một chủ đề',
    'zh-TW': '選取主旨',
    'pt-PT': 'Selecione um assunto',
  },
  'subject-suggestion': {
    'en-US': 'Suggestion',
    'zh-CN': '建议',
    'it-IT': 'Suggerimento',
    'es-ES': 'Sugerencia',
    'de-DE': 'Vorschlag',
    'es-MX': 'Sugerencia',
    'pt-BR': 'Sugestão',
    'ko-KR': '제안 사항',
    'ja-JP': '提案',
    'tr-TR': 'Öneri',
    'ar-AE': 'مقترحات',
    'nl-NL': 'Suggestie',
    'nl-BE': 'Suggestie',
    'pl-PL': 'Sugestia',
    'hi-IN': 'सुझाव',
    'ta-IN': 'பரிந்துரை',
    'bn-IN': 'পরামর্শ',
    'gu-IN': 'સૂચન',
    'ml-IN': 'നിർദ്ദേശം',
    'te-IN': 'సూచన',
    'vi-VN': 'Đề xuất',
    'zh-TW': '建議',
    'pt-PT': 'Sugestão',
  },
  'subject-technical': {
    'en-US': 'Technical issue',
    'zh-CN': '技术问题',
    'fr-FR': 'Problème technique',
    'fr-BE': 'Problème technique',
    'it-IT': 'Problema tecnico',
    'es-ES': 'Problema técnico',
    'de-DE': 'Technisches Problem',
    'es-MX': 'Problema técnico',
    'pt-BR': 'Problema técnico',
    'ko-KR': '기술 문제',
    'ja-JP': '技術的な問題',
    'tr-TR': 'Teknik sorun',
    'ar-AE': 'مشكلة فنيه',
    'nl-NL': 'Technisch probleem',
    'nl-BE': 'Technisch probleem',
    'pl-PL': 'Problem techniczny',
    'hi-IN': 'तकनीकी समस्या',
    'ta-IN': 'தொழில்நுட்பப் பிரச்சினை',
    'bn-IN': 'প্রযুক্তিগত সমস্যা',
    'gu-IN': 'ટેકનિકલ સમસ્યા',
    'ml-IN': 'സാങ്കേതിക പ്രശ്നം',
    'te-IN': 'సాంకేతిక సమస్య',
    'vi-VN': 'Vấn đề kỹ thuật',
    'zh-TW': '技術問題',
    'pt-PT': 'Problema técnico',
  },
  'subject-compliment': {
    'en-US': 'Compliment',
    'zh-CN': '正面',
    'it-IT': 'Complimento',
    'es-ES': 'Felicitaciones',
    'de-DE': 'Kompliment',
    'es-MX': 'Felicitaciones',
    'pt-BR': 'Elogio',
    'ko-KR': '칭찬',
    'ja-JP': '良かった点',
    'tr-TR': 'Övgü',
    'ar-AE': 'مجامله',
    'pl-PL': 'Komplement',
    'hi-IN': 'तारीफ़',
    'ta-IN': 'பாராட்டு',
    'bn-IN': 'প্রশংসা',
    'gu-IN': 'પ્રશંસા',
    'ml-IN': 'പാരിതോഷികം',
    'te-IN': 'కాంప్లిమెంట్',
    'vi-VN': 'Lời khen',
    'zh-TW': '表揚',
    'pt-PT': 'Elogio',
  },
  'subject-other': {
    'en-US': 'Other',
    'zh-CN': '其他',
    'fr-FR': 'Autre',
    'fr-BE': 'Autre',
    'it-IT': 'Altro',
    'es-ES': 'Otros',
    'de-DE': 'Sonstiges',
    'es-MX': 'Otros',
    'pt-BR': 'Outros',
    'ko-KR': '기타',
    'ja-JP': 'その他',
    'tr-TR': 'Diğer',
    'ar-AE': 'أخرى',
    'nl-NL': 'Overig',
    'nl-BE': 'Overig',
    'pl-PL': 'Inny',
    'hi-IN': 'दूसरा',
    'ta-IN': 'மற்றவை',
    'bn-IN': 'অন্যান্য',
    'gu-IN': 'અન્ય',
    'ml-IN': 'മറ്റുള്ളവ',
    'te-IN': 'ఇతర',
    'vi-VN': 'Khác',
    'zh-TW': '其他',
    'pt-PT': 'Outro(s)',
  },
  'chars-remaining': {
    'en-US': 'characters remaining',
    'zh-CN': '剩余字符数',
    'fr-FR': 'caractères restants',
    'fr-BE': 'caractères restants',
    'it-IT': 'caratteri rimasti',
    'es-ES': 'caracteres restantes',
    'de-DE': 'verbleibende Zeichen',
    'es-MX': 'caracteres restantes',
    'pt-BR': 'caracteres restantes',
    'ko-KR': '자 남음',
    'ja-JP': '文字入力できます',
    'tr-TR': 'karakter kaldı',
    'ar-AE': 'الأحرف المتبقية',
    'nl-NL': 'tekens resterend',
    'nl-BE': 'tekens resterend',
    'pl-PL': 'pozostało znaków',
    'hi-IN': 'बाकी बचे हुए कैरेक्टर',
    'ta-IN': 'மீதமுள்ள எழுத்துக்கள்',
    'bn-IN': 'অক্ষর বাকি আছে',
    'gu-IN': 'બાકી અક્ષરો',
    'ml-IN': 'ശേഷിക്കുന്ന പ്രതീകങ്ങൾ',
    'te-IN': 'మిగిలిన అక్షరాలు',
    'vi-VN': 'ký tự còn lại',
    'zh-TW': '剩餘字元',
    'pt-PT': 'caracteres restantes',
  },
  thanks: {
    'en-US': 'Thank you! Your feedback has been submitted.',
    'zh-CN': '谢谢！您的反馈已提交。',
    'fr-FR': 'Merci ! Votre évaluation a été envoyée.',
    'fr-BE': 'Merci ! Votre évaluation a été envoyée.',
    'it-IT': 'Grazie! Il suo feedback è stato inviato.',
    'es-ES': '¡Gracias! Tu valoración se ha enviado correctamente.',
    'de-DE': 'Vielen Dank! Ihre Bewertung wurde übermittelt.',
    'es-MX': '¡Gracias! Tu valoración se ha enviado correctamente.',
    'pt-BR': 'Obrigado! Sua avaliação foi enviada.',
    'ko-KR': '감사합니다. 귀하의 피드백이 제출되었습니다.',
    'ja-JP': 'ありがとうございました。フィードバックが送信されました。',
    'ar-AE': 'شكرا لك! لقد تم إرسال ملاحظتك',
    'nl-NL': 'Bedankt! Je feedback is ingediend.',
    'nl-BE': 'Bedankt! Je feedback is ingediend.',
    'pl-PL': 'Dziękujemy! Twoja opinia została przesłana.',
    'hi-IN': 'धन्यवाद! आपका फ़ीडबैक सबमिट हो गया है.',
    'ta-IN': 'நன்றி! உங்கள் ஃபீட்பேக் சமர்ப்பிக்கப்பட்டுள்ளது.',
    'bn-IN': 'ধন্যবাদ! আপনার প্রতিক্রিয়া জমা দেওয়া হয়েছে।',
    'gu-IN': 'આભાર! તમારો ફીડબેક સબમિટ કરવામાં આવ્યો છે.',
    'ml-IN': 'നന്ദി! നിങ്ങളുടെ ഫീഡ്ബാക്ക് സമർപ്പിച്ചു.',
    'te-IN': 'ధన్యవాదాలు! మీ ఫీడ్‌బ్యాక్ సమర్పించబడింది.',
    'vi-VN': 'Cảm ơn bạn! Phản hồi của bạn đã được gửi.',
    'zh-TW': '感謝您！ 您的意見回饋已提交。',
    'pt-PT': 'Obrigado! O seu feedback foi enviado.',
  },
  'popup-prompt': {
    'en-US': 'What is personal or sensitive data?',
    'zh-CN': '什么是个人或敏感数据？',
    'fr-FR': 'Que sont les données personnelles ou sensibles ?',
    'fr-BE': 'Que sont les données personnelles ou sensibles ?',
    'it-IT': 'Cosa sono i dati personali o riservati?',
    'es-ES': '¿Qué son los datos personales o confidenciales?',
    'de-DE': 'Was sind personenbezogene oder sensible Daten?',
    'es-MX': '¿Qué son los datos personales o confidenciales?',
    'pt-BR': 'O que são dados pessoais ou confidenciais?',
    'ko-KR': '개인 데이터 또는 민감한 데이터는 무엇입니까?',
    'ja-JP': '個人情報や機密性の高いデータとは何ですか ?',
    'tr-TR': 'Kişisel veya hassas veriler nedir?',
    'ar-AE': 'ما هي البيانات الشخصية أو الحساسة؟',
    'nl-NL': 'Wat zijn persoonlijke of gevoelige gegevens?',
    'nl-BE': 'Wat zijn persoonlijke of gevoelige gegevens?',
    'pl-PL': 'Co to są dane osobowe lub poufne?',
    'hi-IN': 'निजी या संवेदनशील डेटा क्या है?',
    'ta-IN': 'தனிப்பட்ட அல்லது பாதுகாக்க வேண்டிய தரவு என்றால் என்ன?',
    'bn-IN': 'ব্যক্তিগত বা সংবেদনশীল তথ্য কী?',
    'gu-IN': 'વ્યક્તિગત અથવા સંવેદનશીલ ડેટા શું છે?',
    'ml-IN': 'വ്യക്തിഗതമോ സെൻസിറ്റീവോ ആയ ഡാറ്റ എന്നാൽ എന്താണ്?',
    'te-IN': 'వ్యక్తిగత లేదా సున్నితమైన డేటా అంటే ఏమిటి?',
    'vi-VN': 'Thế nào là dữ liệu cá nhân hay dữ liệu nhạy cảm?',
    'zh-TW': '什麼是個人或敏感資料？',
    'pt-PT': 'O que são dados pessoais ou confidenciais?',
  },
  'textarea-placeholder': {
    'en-US': 'Do not include personal or sensitive data in your feedback.',
    'zh-CN': '请勿在您的反馈中包含个人或敏感数据。',
    'fr-FR':
      "N'incluez pas de données personnelles ou sensibles dans vos commentaires.",
    'fr-BE':
      "N'incluez pas de données personnelles ou sensibles dans vos commentaires.",
    'it-IT':
      "Non inserire dati personali o sensibili all'interno del testo relativo al tuo feedback.",
    'es-ES': 'No incluyas datos personales o confidenciales en tu valoración.',
    'de-DE':
      'Fügen Sie keine persönlichen oder vertraulichen Daten zu Ihrem Feedback hinzu. ',
    'es-MX':
      'No incluyas datos personales o confidenciales en tus comentarios.',
    'pt-BR': 'Não inclua dados pessoais ou confidenciais em seus comentários.',
    'ko-KR': '피드백에 개인 또는 민감한 데이터를 포함하지 마십시오.',
    'ja-JP':
      '個人情報や機密性の高いデータをフィードバックに含めないでください。',
    'tr-TR': 'Geri bildiriminize kişisel veya hassas verileri dahil etmeyin.',
    'ar-AE': 'لا ترسل بيانات شخصية أو حساسة بملاحظاتك',
    'nl-NL': 'Neem geen persoonlijke of gevoelige gegevens op in je feedback.',
    'nl-BE': 'Neem geen persoonlijke of gevoelige gegevens op in je feedback.',
    'pl-PL': 'Nie umieszczaj w opinii żadnych danych osobowych ani poufnych.',
    'hi-IN': 'अपने फ़ीडबैक में निजी या संवेदनशील डेटा न डालें.',
    'ta-IN':
      'உங்கள் கருத்துகளில் தனிப்பட்ட அல்லது முக்கியத் தரவை சேர்க்க வேண்டாம்.',
    'bn-IN':
      'আপনার প্রতিক্রিয়ায় ব্যক্তিগত বা সংবেদনশীল তথ্য অন্তর্ভুক্ত করবেন না।',
    'gu-IN': 'તમારી પ્રતિસાદમાં વ્યક્તિગત અથવા સંવેદનશીલ ડેટા શામેલ કરશો નહીં.',
    'ml-IN':
      'നിങ്ങളുടെ ഫീഡ്ബാക്കിൽ വ്യക്തിപരമോ സെൻസിറ്റീവോ ആയ ഡാറ്റ ഉൾപ്പെടുത്തരുത്.',
    'te-IN': 'మీ ఫీడ్‌బ్యాక్‌లో వ్యక్తిగత లేదా సున్నితమైన డేటాను చేర్చవద్దు.',
    'vi-VN':
      'Không bao gồm dữ liệu cá nhân hoặc dữ liệu nhạy cảm trong phản hồi của bạn.',
    'zh-TW': '請勿在您的意見回饋中提供個人或機密資料。',
    'pt-PT': 'Não inclua dados pessoais ou confidenciais no feedback.',
  },
  'modal-title': {
    'en-US': 'Rate This Page',
    'zh-CN': '为此页评级',
    'fr-FR': 'Évaluez cette page',
    'fr-BE': 'Évaluez cette page',
    'it-IT': 'Valuta questa pagina',
    'es-ES': 'Valora esta página',
    'de-DE': 'Diese Seite bewerten',
    'es-MX': 'Calificar esta página',
    'pt-BR': 'Avaliar esta página',
    'ko-KR': '이 페이지 평가',
    'ja-JP': 'このページを評価する',
    'tr-TR': 'Bu sayfayı değerlendir',
    'ar-AE': 'قم بتقييم هذه الصفحة',
    'nl-NL': 'Deze pagina beoordelen',
    'nl-BE': 'Deze pagina beoordelen',
    'pl-PL': 'Oceń tę stronę',
    'hi-IN': 'इस पृष्ठ को रेट करें',
    'ta-IN': 'இந்தப் பக்கத்தை மதிப்பீடு செய்யவும்',
    'bn-IN': 'এই পৃষ্ঠাটিতে রেট দিন',
    'gu-IN': 'આ પેજને રેટ કરો',
    'ml-IN': 'ഈ പേജ് റേറ്റ് ചെയ്യുക',
    'te-IN': 'ఈ పేజీని రేట్ చేయండి',
    'vi-VN': 'Đánh giá trang này',
    'zh-TW': '為這個頁面評分',
    'pt-PT': 'Avaliar esta página',
  },
  'very-unsatisfied-option': {
    'en-US': 'Very unsatisfied',
    'fr-FR': 'très insatisfait',
    'fr-BE': 'très insatisfait',
    'zh-CN': '非常不满意',
    'ja-JP': '非常に不満',
    'es-ES': 'muy insatisfecho',
    'de-DE': 'sehr unzufrieden',
    'es-MX': 'muy insatisfecho',
    'it-IT': 'Molto insoddisfatto',
    'ko-KR': '매우 만족함',
    'pt-BR': 'muito insatisfeito',
    'tr-TR': 'hiç memnun değilim',
    'ar-AE': 'غير راضٍ على الإطلاق',
    'nl-NL': 'zeer ontevreden',
    'nl-BE': 'zeer ontevreden',
    'pl-PL': 'bardzo niezadowolony',
    'hi-IN': 'बहुत असंतुष्ट',
    'ta-IN': 'மிகவும் அதிருப்தி',
    'bn-IN': 'খুবই অসন্তুষ্ট',
    'gu-IN': 'ખૂબ અસંતુષ્ટ',
    'ml-IN': 'തീരെ തൃപ്തികരമല്ല',
    'te-IN': 'అస్సలు సంతృప్తికరంగా లేదు',
    'vi-VN': 'rất không hài lòng',
    'zh-TW': '非常不滿意',
    'pt-PT': 'muito insatisfeito',
  },
  'unsatisfied-option': {
    'en-US': 'Unsatisfied',
    'ja-JP': '不満',
    'fr-FR': 'insatisfait',
    'fr-BE': 'insatisfait',
    'zh-CN': '不满意',
    'it-IT': 'Non soddisfatto',
    'es-ES': 'insatisfecho',
    'de-DE': 'unzufrieden',
    'es-MX': 'insatisfecho',
    'pt-BR': 'insatisfeito',
    'ko-KR': '불만족함',
    'tr-TR': 'memnun değilim',
    'ar-AE': 'غير راضٍ',
    'nl-NL': 'ontevreden',
    'nl-BE': 'ontevreden',
    'pl-PL': 'niezadowolony',
    'hi-IN': 'असंतुष्ट',
    'ta-IN': 'திருப்தியடையவில்லை',
    'bn-IN': 'অসন্তুষ্ট',
    'gu-IN': 'અસંતોષ',
    'ml-IN': 'തൃപ്തികരമല്ല',
    'te-IN': 'అసంతృప్తిగా ఉంది',
    'vi-VN': 'không hài lòng',
    'zh-TW': '不滿意',
    'pt-PT': 'insatisfeito',
  },
  'neutral-option': {
    'en-US': 'Neutral',
    'zh-CN': '中性',
    'ja-JP': 'どちらでもない',
    'fr-FR': 'neutre',
    'fr-BE': 'neutre',
    'pt-BR': 'neutro',
    'ko-KR': '보통',
    'tr-TR': 'kararsızım',
    'ar-AE': 'محايد',
    'nl-NL': 'neutraal',
    'nl-BE': 'neutraal',
    'pl-PL': 'neutralny',
    'hi-IN': 'न तो संतुष्ट और न ही असंतुष्ट',
    'ta-IN': 'நடுநிலை',
    'bn-IN': 'নিরপেক্ষ',
    'gu-IN': 'તટસ્થ',
    'ml-IN': 'നിഷ്പക്ഷം',
    'te-IN': 'తటస్థం',
    'vi-VN': 'bình thường',
    'zh-TW': '中立',
    'pt-PT': 'neutro',
  },
  'satisfied-option': {
    'en-US': 'Satisfied',
    'zh-CN': '满意',
    'ja-JP': '満足',
    'fr-FR': 'satisfait',
    'fr-BE': 'satisfait',
    'it-IT': 'Soddisfatto',
    'es-ES': 'satisfecho',
    'de-DE': 'zufrieden',
    'es-MX': 'satisfecho',
    'pt-BR': 'satisfeito',
    'ko-KR': '만족함',
    'tr-TR': 'memnunum',
    'ar-AE': 'راضٍ',
    'nl-NL': 'tevreden',
    'nl-BE': 'tevreden',
    'pl-PL': 'zadowolony',
    'hi-IN': 'संतुष्ट',
    'ta-IN': 'திருப்தி',
    'bn-IN': 'সন্তুষ্ট',
    'gu-IN': 'સંતુષ્ટ',
    'ml-IN': 'തൃപ്തികരം',
    'te-IN': 'సంతృప్తికరంగా ఉంది',
    'vi-VN': 'hài lòng',
    'zh-TW': '滿意',
    'pt-PT': 'satisfeito',
  },
  'very-satisfied-option': {
    'en-US': 'Very satisfied',
    'zh-CN': '非常满意',
    'ja-JP': '非常に満足',
    'it-IT': 'Molto soddisfatto',
    'fr-FR': 'très satisfait',
    'fr-BE': 'très satisfait',
    'es-ES': 'muy satisfecho',
    'de-DE': 'sehr zufrieden',
    'es-MX': 'muy satisfecho',
    'pt-BR': 'muito satisfeito',
    'ko-KR': '매우 만족함',
    'tr-TR': 'çok memnunum',
    'ar-AE': 'راضٍ جدًا',
    'nl-NL': 'zeer tevreden',
    'nl-BE': 'zeer tevreden',
    'pl-PL': 'bardzo zadowolony',
    'hi-IN': 'बहुत संतुष्ट',
    'ta-IN': 'மிகவும் திருப்தி',
    'bn-IN': 'খুব সন্তুষ্ট',
    'gu-IN': 'ખૂબ સંતુષ્ટ',
    'ml-IN': 'വളരെ തൃപ്തികരം',
    'te-IN': 'చాలా సంతృప్తికరంగా ఉంది',
    'vi-VN': 'rất hài lòng',
    'zh-TW': '非常滿意',
    'pt-PT': 'muito satisfeito',
  },
};

export default katTranslator(strings);
